<template>
    <div>
        <div v-if="!isSizeMd">
            <div class="pizzeria-city button-location" @click="setChangeLocation">
                {{phrases.TEXT_FREE_PIZZA_DELIVERY_FOR }}<br>
                <span class="pizzeria-city-button button-location-city">
                  {{phrases['TEXT_IN_CITY_' + city_code.toUpperCase()] }}
                </span>
            </div>
        </div>
        <div v-if="isSizeMd">
            <div class="pizzeria-city button-location" @click="setChangeLocation">
                <div class="pp-icon pp-icon-location"></div>
                <div class="pizzeria-city-button button-location-city">{{pizzeria.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";

    export default {
        name: "ButtonLocation",
        props: ['isSizeMd'],
        data: function () {
            return {
                changeCityBalloon: false,
            }
        },
        computed:{
            ...mapGetters('app', {
                pizzeria: 'getPizzeriaInfo',
                phrases: 'getPhrases',
                city_code: 'getCityCode',
                pizzeria_list: 'getChangeLocation',
            }),
        },
        mixins:[Utils]
    }
</script>

<style lang="scss">
.button-location-city {
  cursor: pointer;
  border: 0;
  &:hover {
    color: #000;
    text-decoration: underline;
  }
}
</style>
